<template>
	<sf-modal-layout
		class="mapping-program-process__popup"
		size="xl"
		:title="getMessage_('SWCC000386')"
		ref="modal"
		:show="show"
		:closeModal="closeModal"
	>
		<div class="el-dialog__body__form-area">
			<!-- Plant Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000247')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-select-group
							:inputValue="selectedRow.plantCd"
							:options="plants_"
							:onChange="value => onChange({ key: 'plantCd', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Plant End -->

			<!-- Program ID Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000366')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-select-group
							:inputValue="selectedRow.pgmId"
							:options="
								pgmIds_.filter(pgmId => pgmId.label !== 'ALL').map(pgmId => ({ ...pgmId, label: `${pgmId.label} : ${pgmId.value}` }))
							"
							:disabled="disabled"
							:onChange="value => onChange({ key: 'pgmId', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Program ID End -->

			<!-- Process ID Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000284')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-select-group
							:inputValue="selectedRow.procId"
							:disabled="disabled"
							:options="
								procIds_.filter(procId => procId.label !== 'ALL').map(procId => ({ ...procId, label: `${procId.label} : ${procId.value}` }))
							"
							:onChange="value => onChange({ key: 'procId', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Process ID End -->

			<!-- 순서 Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000373')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-input-group
							inputType="number"
							:elProps="{ min: 1 }"
							:inputValue="selectedRow.exeSeq"
							:onChange="value => onChange({ key: 'exeSeq', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- 순서 End -->

			<!-- Proc Run Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000374')" labelPosition="left" :gutter="30" :labelSpan="12">
						<el-checkbox :value="selectedRow.procExeStat" @change="value => onChange({ key: 'procExeStat', value })" />
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Proc Run End -->

			<!-- Proc Control Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000376')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-select-group
							:inputValue="selectedRow.procControl"
							:options="[
								{ label: 'START', value: '1' },
								{ label: 'STOP', value: '0' },
								{ label: 'HOLDING', value: null }
							]"
							:onChange="value => onChange({ key: 'procControl', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Proc Control End -->

			<!-- Resp Port Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000377')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-input-group
							inputType="number"
							:inputValue="selectedRow.respPort"
							:onChange="value => onChange({ key: 'respPort', value })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Resp Port End -->

			<!-- Heart Bit Cycle Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000379')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-input-group
							:inputValue="selectedRow.procStatUpTime"
							:onChange="value => onChange({ key: 'procStatUpTime', value })"
							inputType="number"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Heart Bit Cycle End -->

			<!-- Server IP Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000381')" labelPosition="left" :gutter="30" :labelSpan="12">
						<sf-input-group :inputValue="selectedRow.svrIp" :onChange="value => onChange({ key: 'svrIp', value })" />
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Server IP End -->

			<!-- Watch Flag Start -->
			<el-row class="w-100" :gutter="30">
				<el-col :span="24">
					<sf-group-wrapper :label="getMessage_('SWCC000382')" labelPosition="left" :gutter="30" :labelSpan="12">
						<el-checkbox
							:value="selectedRow.stateMonFlg === '1'"
							@change="value => onChange({ key: 'stateMonFlg', value: value ? '1' : '0' })"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<!-- Watch Flag End -->
		</div>

		<div class="el-dialog__body__table-queue-mapping-area">
			<div style="width: 45%">
				<sf-data-table ref="queueTable" height="500px" selection :columns="columns" :rows="queues" />
			</div>
			<div style="width: 10%; display: flex; align-items: center; justify-content: center">
				<div style="width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center">
					<sf-button line class="icon-sf-caret-left" style="margin: 0 0 10px 0" :onClick="onLeft" />
					<sf-button line class="icon-sf-caret-right" style="margin: 10px 0 0 0" :onClick="onRight" />
				</div>
			</div>
			<div style="width: 45%">
				<sf-card style="width: 100%; height: 500px" title="AQ List">
					<sf-data-table ref="aqTable" selection :columns="columns" :rows="pgmQueueMaps" />
				</sf-card>
			</div>
		</div>

		<template v-slot:footer>
			<sf-button
				v-if="isButton_(scrId, 'CD')"
				v-show="disabled"
				line
				color="error"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000280'), clickFn: removeMapping }]
						})
				"
				>{{ getMessage_('SWCC000280') }}</sf-button
			>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="!disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000245'), clickFn: registerMapping }]
						})
				"
				>{{ getMessage_('SWCC000245') }}</sf-button
			>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000553'),
							buttons: [{ title: getMessage_('SWCC000279'), clickFn: modifyMapping }]
						})
				"
				>{{ getMessage_('SWCC000279') }}</sf-button
			>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MappingProgramProcess/store/helpers';
import moment from 'moment';
import * as yup from 'yup';
import { utils } from '@sfaas/util';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchQueues_({ plantCd: this.user.plantCd }).finally(() => this.$sf_toggleLoading(false));
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onRight() {
			const queueTable = this.$refs.queueTable;
			const selectedRows = queueTable.getSelectedRows();
			const pgmQueueMaps = this.pgmQueueMaps.slice();
			selectedRows.forEach(selectedRow => {
				const { queueId } = selectedRow;
				if (Array.isArray(pgmQueueMaps) && pgmQueueMaps.length === 0) {
					pgmQueueMaps.push(selectedRow);
				} else if (!pgmQueueMaps.map(pgmQueueMap => pgmQueueMap.queueId).includes(queueId)) {
					pgmQueueMaps.push(selectedRow);
				}
			});
			this.DEFAULT_ASSIGN({ key: 'pgmQueueMaps', value: pgmQueueMaps });
			queueTable.clearSelection();
		},
		onLeft() {
			const aqTable = this.$refs.aqTable;
			const selectedRows = aqTable.getSelectedRows();
			const pgmQueueMaps = this.pgmQueueMaps.slice();
			pgmQueueMaps.forEach((pgmQueueMap, index) => {
				const { queueId } = pgmQueueMap;
				if (selectedRows.map(selectedRow => selectedRow.queueId).includes(queueId)) {
					delete pgmQueueMaps[index];
				}
			});
			this.DEFAULT_ASSIGN({ key: 'pgmQueueMaps', value: pgmQueueMaps.filter(pgmQueueMap => !this.isUndefined(pgmQueueMap)) });
			aqTable.clearSelection();
		},
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: '',
					show: false,
					selectedRow: {}
				}
			});
		},
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					...this.popupParams,
					selectedRow: {
						...this.selectedRow,
						[key]: value
					}
				}
			});
		},
		async registerMapping() {
			try {
				this.schema.validateSync(this.mapping);
				this.$sf_toggleLoading(true);
				await this.createMapping_({
					mapping: { ...this.mapping, regDate: moment().format('YYYYMMDD'), regTime: moment().format('HHmmss') }
				}).then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				});
				await this.updatePgmQueueMaps_({
					plantCd: this.user.plantCd,
					pgmId: this.mapping.pgmId,
					procId: this.mapping.procId,
					pgmQueueMapList: this.pgmQueueMaps.map(pgmQueueMap => ({
						...pgmQueueMap,
						pgmId: this.mapping.pgmId,
						procId: this.mapping.procId
					}))
				})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(() => this.fetchPgmQueueMaps_({ plantCd: this.user.plantCd, pgmId: this.mapping.pgmId, procId: this.mapping.procId }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async modifyMapping() {
			try {
				this.schema.validateSync(this.mapping);
				this.$sf_toggleLoading(true);
				await this.updateMapping_({
					mapping: { ...this.mapping, chgDate: moment().format('YYYYMMDD'), chgTime: moment().format('HHmmss') }
				}).then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				});
				await this.updatePgmQueueMaps_({
					plantCd: this.user.plantCd,
					pgmId: this.mapping.pgmId,
					procId: this.mapping.procId,
					pgmQueueMapList: this.pgmQueueMaps.map(pgmQueueMap => ({
						...pgmQueueMap,
						pgmId: this.mapping.pgmId,
						procId: this.mapping.procId
					}))
				})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(() => this.fetchPgmQueueMaps_({ plantCd: this.user.plantCd, pgmId: this.mapping.pgmId, procId: this.mapping.procId }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async removeMapping() {
			try {
				this.schema.validateSync(this.mapping);
				this.$sf_toggleLoading(true);
				await this.deletePgmQueueMaps_({ plantCd: this.user.plantCd, pgmId: this.mapping.pgmId, procId: this.mapping.procId });
				await this.deleteMapping_({ mapping: this.mapping })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		procExeStatConverter(procExeStat) {
			switch (procExeStat) {
				case true:
					return 'Y';
				case false:
					return 'N';
				default:
					return procExeStat;
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			const columns = [
				{ label: 'Queue', prop: 'queueId', minWidth: 130 },
				{
					label: 'Type',
					prop: 'queueType',
					minWidth: 100,
					form: {
						type: 'select',
						options: [
							{ label: 'Plan', value: 'P' },
							{ label: 'Report', value: 'R' },
							{ label: 'Order', value: 'O' },
							{ label: 'Summary', value: 'S' },
							{ label: 'Answer', value: 'A' }
						]
					}
				},
				{
					label: 'Kind',
					prop: 'queueKind',
					minWidth: 100,
					form: {
						type: 'select',
						options: [
							{ label: 'Dequeue', value: 'D' },
							{ label: 'Enqueue', value: 'E' }
						]
					}
				}
			];
			return columns;
		},
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		disabled() {
			const { type } = this.popupParams;
			return type.includes('update');
		},
		show() {
			const { show } = this.popupParams;
			return show;
		},
		selectedPgmId() {
			const { pgmId } = this.selectedRow;
			return pgmId;
		},
		mapping() {
			return {
				...this.selectedRow,
				procExeStat: this.procExeStatConverter(this.selectedRow.procExeStat)
			};
		},
		schema() {
			return yup.object().shape({
				pgmId: yup.string().nullable().required(this.getMessage_('SWCC000498')),
				procId: yup.string().nullable().required(this.getMessage_('SWCC000500')),
				exeSeq: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000373')]))
					.nullable()
					.required(this.getMessage_('SWCC000506')),
				respPort: yup
					.number()
					.nullable()
					.max(
						38,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000377'),
							38
						])
					),
				svrIp: yup
					.string()
					.nullable()
					.default('')
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000381'),
							20
						])
					)
			});
		}
	},
	watch: {
		show_(value, oldValue) {
			if (value) {
				this.$sf_toggleLoading(true);
				this.fetchProcIds_({ plantCd: this.user.plantCd }).finally(() => this.$sf_toggleLoading(false));
			} else {
				this.$sf_toggleLoading(true);
				this.fetchProcIdsByPgmId_({ plantCd: this.user.plantCd, pgmId: this.pgmId_ }).finally(() => this.$sf_toggleLoading(false));
			}
		}
	}
};
</script>

<style lang="scss">
.mapping-program-process {
	&__popup {
		.el-dialog__body {
			display: flex;
			&__form-area {
				width: 35%;
			}
			&__table-queue-mapping-area {
				width: 65%;
				display: flex;
			}
		}
	}
}
</style>
